module.exports = __webpack_public_path__ + "media/images/paddenstoel-c0c3f138cc06db148f7c9013c8422f8a.jpg";